import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalService } from '../modal.service';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import * as RouterActions from '../../router/state/router.actions';

@Component({
  selector: 'app-in-use-modal',
  templateUrl: './in-use-modal.component.html',
  styleUrls: ['./in-use-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InUseModalComponent {
  contactUsUrl = `${environment.publicSiteUrl}/talk-to-us`;

  constructor(private modalService: ModalService, private store: Store<AppState>) {}

  onModalClose() {
    this.store.dispatch(RouterActions.Go({ path: ['locations'] }));
    this.modalService.close('in-use-message');
  }

  onModalCloseAndOpenTalkToUsPage() {
    this.store.dispatch(RouterActions.Go({ path: ['locations'] }));
    window.open(this.contactUsUrl, '_blank');
    this.modalService.close('in-use-message');
  }
}
